// @flow
import React, { Component } from "react";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";

import { GeneralModalForm } from "imagus-components";
import CreateFacebaseFormRedux from "../../containers/facebases/CreateFacebaseFormRedux";

type FacebaseItemPropsType = {
  facebase: { [key: string]: * },
  company: { [key: string]: * },
  isAdmin?: boolean,
  isFacebaseAdmin?: boolean
};

type FacebaseItemStatesType = {
  modalOpen: boolean
};

class FacebaseItem extends Component<
  FacebaseItemPropsType,
  FacebaseItemStatesType
> {
  constructor(props: FacebaseItemPropsType) {
    super(props);
    this.state = {
      modalOpen: false
    };
  }

  switchModalStatus = (status: boolean): * => {
    this.setState({ modalOpen: status });
  };

  render(): * {
    const facebase = this.props.facebase;
    return (
      <div>
        <ListItem divider>
          <ListItemText
            primary={facebase.name}
            secondary={
              <span>
                <span className="right-margin-10">
                  Limit: <b>{facebase.personLimit}</b>
                </span>
                {this.props.isFacebaseAdmin && (
                  <span>
                    Model:{" "}
                    <b>
                      <span
                        className={facebase.model !== 16 ? "red-label" : ""}
                      >
                        {facebase.model}
                      </span>
                    </b>
                  </span>
                )}
              </span>
            }
          />
          {this.props.isFacebaseAdmin && (
            <ListItemSecondaryAction>
              <IconButton
                aria-label="Edit"
                onClick={(): * => this.switchModalStatus(true)}
              >
                <EditIcon className="shine-icon" />
              </IconButton>
            </ListItemSecondaryAction>
          )}
        </ListItem>
        {this.props.isFacebaseAdmin && (
          <GeneralModalForm
            title={"Edit Facebase " + facebase.name}
            open={this.state.modalOpen}
            handleModalStatus={this.switchModalStatus}
            form={
              <CreateFacebaseFormRedux
                onClose={(): * => this.switchModalStatus(false)}
                facebase={facebase}
                company={this.props.company}
                isAdmin={this.props.isAdmin}
              />
            }
          />
        )}
      </div>
    );
  }
}

export default FacebaseItem;
